import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import VueI18n from 'vue-i18n'
import en from './locale/en.js'
import es from './locale/es.js'
import pt from './locale/pt.js'
import ca from './locale/ca.js'

import VueResource from 'vue-resource'

import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

import { ErrorManager } from './services/error.service'
var pjson = require('../package.json')

const errorManager = new ErrorManager()

Vue.config.productionTip = false

const bugsnagClient = bugsnag({ apiKey: '46a304030792b790573384d357c43afa', appVersion: pjson.version })
bugsnagClient.use(bugsnagVue, Vue)

window.bugsnagClient = bugsnagClient

window.IBAN = require('iban')
window.CBU = require('arg.js').cbu;
window.CUIT = require('arg.js').cuit;
window.CLABE = require('clabe-validator').clabe; 
window.RFC = require('validate-rfc');
window.phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()

Vue.use(Vuetify, {
  theme: {
    primary: '#37474F',
    secondary: '#dbe0e2',
    error: '#ff8686'
  }
})

Vue.use(VueResource)
Vue.http.interceptor.before = function (request, next) {
  store.commit('setLoading', true)
  next(response => {
    if (!response.ok) {
      errorManager.manageError(response)
    }
    store.commit('setLoading', false)
  })
}

Vue.use(VueI18n)
const messages = {
  en,
  es,
  pt,
  ca
}
const i18n = new VueI18n({
  locale:
    (navigator.language || navigator.userLanguage).split('-')[0] === 'es'
      ? 'es'
      : (navigator.language || navigator.userLanguage).split('-')[0] === 'pt'
        ? 'pt'
        : (navigator.language || navigator.userLanguage).split('-')[0] === 'ca'
          ? 'ca'
          : 'en',
  messages
})
document.getElementsByTagName('html')[0].lang = 
  (navigator.language || navigator.userLanguage).split('-')[0] === 'es' 
    ? 'es' 
    : (navigator.language || navigator.userLanguage).split('-')[0] === 'pt' 
      ? 'pt' 
      : (navigator.language || navigator.userLanguage).split('-')[0] === 'ca'
        ? 'ca'
        : 'en'

window.vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
